module.exports = __webpack_public_path__ + "static/media/TMT 1a2.e7154581.jpg";